var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.322813 6.168L16.2727 0.0523714C16.3636 0.00737085 16.466 -0.00918817 16.5665 0.00486528C16.6669 0.0189187 16.7608 0.0629287 16.8358 0.131125C16.9108 0.199322 16.9633 0.288522 16.9866 0.387032C17.0099 0.485542 17.0027 0.588763 16.9661 0.683163L10.8636 16.6757C10.8287 16.7676 10.7674 16.8474 10.6875 16.905C10.6075 16.9625 10.5124 16.9954 10.4139 16.9996C10.3153 17.0037 10.2178 16.9789 10.1333 16.9282C10.0487 16.8775 9.98103 16.8031 9.9385 16.7144L7.47945 11.6404L12.3601 4.67264L5.38793 9.52669L0.285365 7.08929C0.196763 7.04682 0.122566 6.9794 0.0719291 6.89536C0.0212923 6.81132 -0.00356873 6.71433 0.000413336 6.61637C0.0043954 6.5184 0.0370464 6.42374 0.0943377 6.34406C0.151629 6.26439 0.231054 6.20318 0.322813 6.168Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c8905f51208284804ec7377903c275f7.svg";
export { ForwardRef as ReactComponent };